export default "__VITE_ASSET__DkKFmrXd__"